import { FunctionComponent } from 'react';
import { SerializedStyles, css } from '@emotion/react';

interface Props {
  className?: string;
  innerCss?: SerializedStyles;
}

const base = css`
  background-color: transparent;
  padding: 1.8rem;
`;

const inner = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ControlPanel: FunctionComponent<Props> = ({ children, innerCss, className }) => {
  return (
    <div className={className} css={base}>
      <div css={[inner, innerCss]}>{children}</div>
    </div>
  );
};

export default ControlPanel;
